import type {EditorView} from '@codemirror/view'
import {createContext} from 'react'

import type {SelectionContextValue} from '../codemirror/extensions/selection-context'

export interface ToolbarContext {
  view: EditorView | null
  selectedNodes: SelectionContextValue
}

/** Provides toolbar button access to the hybrid editor's CodeMirror view and stateful values. */
export const ToolbarContext = createContext<ToolbarContext>({
  view: null,
  selectedNodes: [],
})
